import { component } from 'picoapp';

export default component(async (node) => {
  const buttons = node.querySelectorAll('button');

  const { product, relation } = node.dataset;

  buttons.forEach((button) => {
    const { handle } = button.dataset;

    button.addEventListener('click', () => {
      const event = new CustomEvent('theme:product:swap', {
        detail: {
          handle,
          product,
          relation,
        },
      });

      document.dispatchEvent(event);
    });
  });
});
